import { GET_GENERAL_REPORTS_SUCCESS, GET_SIGNATURE_REPORTS_SUCCESS } from './reports.types';

const initialState = {
    generalReports: null,
    signatureReports: null,
};

export const reportsReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Reports */

        case GET_GENERAL_REPORTS_SUCCESS:
            return {
                ...state,
                generalReports: action?.payload,
            };

        case GET_SIGNATURE_REPORTS_SUCCESS:
            return {
                ...state,
                signatureReports: action?.payload,
            };

        /** End */

        default:
            return state;
    }
};
